import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseLikeFilled: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0607 20.5607L20.5607 13.0607C22.5272 11.0942 22.5272 7.90585 20.5607 5.93935C18.5942 3.97285 15.4058 3.97286 13.4394 5.93935L12 7.37869L10.5607 5.93935C8.59417 3.97285 5.40585 3.97285 3.43935 5.93935C1.47285 7.90585 1.47285 11.0942 3.43935 13.0607L10.9394 20.5607C11.5251 21.1465 12.4749 21.1465 13.0607 20.5607Z"
        fill={color}
      />
    </svg>
  );
};
